import { Link } from 'react-router';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-screen supports-[height:100dvh]:min-h-dvh items-center justify-center bg-gray-50" dir="rtl">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-blue-600">404</h1>
        <p className="mt-4 text-xl text-gray-700">הדף לא נמצא</p>
        <Link
          to="/app"
          className="mt-6 inline-block rounded-xl bg-blue-600 hover:bg-blue-700 px-6 py-3 text-white font-semibold transition-colors"
        >
          חזרה לדשבורד
        </Link>
      </div>
    </div>
  );
}
